import {
  AutocompleteInput,
  ReferenceInput,
  maxLength,
  minLength,
  required,
  useGetIdentity,
} from "react-admin";
import {
  inputText,
  matchSuggestion,
  OptionRenderer,
} from "../../customerDebtPayments/common/CustomSelectOption";
import { useWatch } from "react-hook-form";

const validateCOA = [required(), minLength(36), maxLength(36)];

const PickCOA = () => {
  const dependOnType = useWatch({ name: "type" });
  const { data: identity } = useGetIdentity();
  const coaFilter = identity?.companyID
    ? { all: "1102", company_id: identity.companyID }
    : { all: "1102" };
  const coaFilterToQuery = (searchText) => ({
    all: searchText || "1102",
    ...(identity?.companyID ? { company_id: identity.companyID } : {}),
  });
  return dependOnType === 1 ? (
    <ReferenceInput
      source="chart_of_account_id"
      reference="coa"
      perPage={20}
      sort={{ field: "chart_of_accounts.code", order: "ASC" }}
      filter={coaFilter}
    >
      <AutocompleteInput
        label="mine.label.coa_code"
        variant="outlined"
        fullWidth
        sx={{ display: "inline-flex" }}
        validate={validateCOA}
        optionValue="id"
        // optionText="code"
        optionText={<OptionRenderer />}
        inputText={inputText}
        matchSuggestion={matchSuggestion}
        filterToQuery={coaFilterToQuery}
      />
    </ReferenceInput>
  ) : null;
};

export default PickCOA;
